import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from './index'
import type { ICustomerData } from './customerdata'

export interface IMachine extends Partial<ICustomerData> {
    machineId: string
    /** ISO Date String */
    loggedAt?: string
}

export async function searchMachines(query: string): Promise<ApiResponse<IMachine[]>> {
    const response = await fetch(`${HOST_URL}machines/search`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ query }),
    })
    const result = (await response.json()) as ApiResponse<IMachine[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function saveMachine(machineId: IMachine['machineId'], data: Partial<ICustomerData>): Promise<ApiResponse<void>> {
    if (machineId.startsWith('M-')) {
        machineId = machineId.slice(2)
    }

    const response = await fetch(`${HOST_URL}machines`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ machineId, ...data }),
    })
    const result = (await response.json()) as ApiResponse<void>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getMachine(machineId: IMachine['machineId']): Promise<ApiResponse<IMachine>> {
    if (machineId.startsWith('M-')) {
        machineId = machineId.slice(2)
    }

    const response = await fetch(`${HOST_URL}machines/by-machine-id`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ machineId }),
    })
    const result = (await response.json()) as ApiResponse<IMachine>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
